import { Check } from "lucide-react";

const TargetAudience = () => {
  const bulletPoints = [
    "Já possui ou está construindo patrimônio e quer tomar decisões mais conscientes",
    "Sente falta de uma visão integrada entre suas decisões patrimoniais",
    "Quer organizar melhor temas como investimentos, proteção patrimonial e sucessão",
    "Está em um momento de transição (crescimento de renda, mudança familiar, novos projetos)",
    "Valoriza clareza, estratégia e planejamento de longo prazo",
  ];

  return (
    <section className="py-16 md:py-20 bg-[#112711]">
      <div className="section-container">
        <div className="max-w-2xl mx-auto">
          {/* Title */}
          <h2 className="text-xl md:text-2xl lg:text-3xl font-display font-normal mb-4 text-[#FAFAFA]">
            Para quem essa conversa faz sentido
          </h2>
          
          {/* Intro text */}
          <p className="text-sm md:text-base text-[#FAFAFA]/80 font-body leading-relaxed mb-8">
            Essa conversa pode fazer sentido se você:
          </p>
          
          {/* Bullet points */}
          <ul className="space-y-4">
            {bulletPoints.map((point, index) => (
              <li 
                key={index}
                className="flex items-start gap-3 text-sm md:text-base text-[#FAFAFA] font-body"
              >
                <span className="flex-shrink-0 mt-0.5">
                  <Check className="w-4 h-4 text-[#F3DE2C]" strokeWidth={2} />
                </span>
                <span className="leading-relaxed">{point}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
